import { render, staticRenderFns } from "./DocBadge.vue?vue&type=template&id=8867c2d2&scoped=true&"
import script from "./DocBadge.vue?vue&type=script&lang=js&"
export * from "./DocBadge.vue?vue&type=script&lang=js&"
import style0 from "./DocBadge.vue?vue&type=style&index=0&id=8867c2d2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8867c2d2",
  null
  
)

export default component.exports